export function getFileExtension(url) {
  if (typeof url === 'string') {
    return url
      .toLowerCase()
      .split('.')
      .pop()
      .split(/\#|\?/)[0];
  }
}
